export interface CityTransport {
  car: string;
  duration: string;
  distance: string;
  rer?: string;
  bus?: string;
  parking?: string;
}

export interface City {
  slug: string;
  name: string;
  prefix: string;
  transport: CityTransport;
  localContext: string;
  nearbyLandmarks: string[];
}

export const cities: City[] = [
  {
    slug: 'aulnay-sous-bois',
    name: 'Aulnay-sous-Bois',
    prefix: 'à',
    transport: {
      car: 'Via la RN2 ou la A104, trajet direct et rapide.',
      duration: '10 min en voiture',
      distance: '5 km',
      rer: 'RER B (gare d\'Aulnay-sous-Bois) puis bus 615 direction Sevran.',
      bus: 'Ligne 615 directe jusqu\'au boulevard Westinghouse.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Aulnay-sous-Bois, avec ses 85 000 habitants, est l\'une des plus grandes villes du 93. Body by CC est l\'institut de beauté le plus proche spécialisé en peaux noires et métissées, à seulement 10 minutes en voiture.',
    nearbyLandmarks: ['Parc Robert Ballanger', 'Centre commercial O\'Parinor', 'Gare RER B d\'Aulnay'],
  },
  {
    slug: 'livry-gargan',
    name: 'Livry-Gargan',
    prefix: 'à',
    transport: {
      car: 'Via la D44, trajet direct par Vaujours ou Villepinte.',
      duration: '12 min en voiture',
      distance: '6 km',
      bus: 'Bus 616 ou 147 puis correspondance vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Livry-Gargan, ville résidentielle et verdoyante du 93, est à quelques minutes de Body by CC. Les habitantes de Livry-Gargan apprécient notre expertise en soins du visage et HIFU.',
    nearbyLandmarks: ['Parc de la Mairie', 'Forêt de Bondy', 'Centre-ville de Livry-Gargan'],
  },
  {
    slug: 'villepinte',
    name: 'Villepinte',
    prefix: 'à',
    transport: {
      car: 'Trajet direct via la D40, moins de 10 minutes.',
      duration: '8 min en voiture',
      distance: '4 km',
      rer: 'RER B (gare de Villepinte) puis bus 615 vers Sevran.',
      bus: 'Ligne 615 direction Sevran, arrêt boulevard Westinghouse.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Villepinte est la ville voisine directe de Sevran. L\'institut Body by CC est à moins de 10 minutes, ce qui en fait le choix naturel pour les Villepintoises en quête de soins esthétiques de qualité.',
    nearbyLandmarks: ['Parc des Expositions de Villepinte', 'Gare RER B de Villepinte', 'Centre commercial'],
  },
  {
    slug: 'tremblay-en-france',
    name: 'Tremblay-en-France',
    prefix: 'à',
    transport: {
      car: 'Via la D40 puis D44, trajet rapide et fluide.',
      duration: '12 min en voiture',
      distance: '7 km',
      rer: 'RER B (gare de Vert-Galant) puis correspondance bus vers Sevran.',
      bus: 'Ligne 616 direction Sevran avec correspondance.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Tremblay-en-France, à proximité de l\'aéroport Roissy-CDG, est bien desservie vers Sevran. Les habitantes profitent d\'un institut de beauté expert en technologies de pointe à quelques minutes.',
    nearbyLandmarks: ['Base de loisirs de Tremblay', 'Gare RER B Vert-Galant', 'Centre commercial'],
  },
  {
    slug: 'vaujours',
    name: 'Vaujours',
    prefix: 'à',
    transport: {
      car: 'Via la D44 direction Sevran, route directe.',
      duration: '10 min en voiture',
      distance: '5 km',
      bus: 'Bus 147 vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Vaujours, petite ville paisible à la frontière du 93 et du 77, est à seulement 10 minutes de Body by CC. Un accès facile pour des soins de qualité sans se déplacer loin.',
    nearbyLandmarks: ['Fort de Vaujours', 'Parc communal', 'Centre-ville'],
  },
  {
    slug: 'le-blanc-mesnil',
    name: 'Le Blanc-Mesnil',
    prefix: 'au',
    transport: {
      car: 'Via la A1 ou RN2, accès rapide à Sevran.',
      duration: '15 min en voiture',
      distance: '8 km',
      rer: 'RER B (gare du Blanc-Mesnil) puis bus vers Sevran.',
      bus: 'Ligne 615 avec correspondance.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Le Blanc-Mesnil, desservi par le RER B, est à 15 minutes de Body by CC. Les Blanc-Mesnilloises bénéficient d\'un accès facile en transport ou en voiture pour des soins experts.',
    nearbyLandmarks: ['Musée de l\'Air et de l\'Espace (Le Bourget)', 'Parc Jacques Duclos', 'Gare RER B'],
  },
  {
    slug: 'drancy',
    name: 'Drancy',
    prefix: 'à',
    transport: {
      car: 'Via la RN2 direction Sevran, trajet fluide.',
      duration: '15 min en voiture',
      distance: '9 km',
      rer: 'RER B (gare de Drancy) puis bus 615 ou correspondance.',
      bus: 'Lignes 148 et 615 vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Drancy, grande ville du 93 avec plus de 70 000 habitants, est bien connectée à Sevran par les transports. Body by CC offre aux Drancéennes un accès à des soins esthétiques de pointe.',
    nearbyLandmarks: ['Parc de Ladoucette', 'Mémorial de la Shoah', 'Gare RER B de Drancy'],
  },
  {
    slug: 'bondy',
    name: 'Bondy',
    prefix: 'à',
    transport: {
      car: 'Via la RN3 puis D44 direction Sevran.',
      duration: '18 min en voiture',
      distance: '10 km',
      rer: 'RER E (gare de Bondy) puis correspondance bus.',
      bus: 'Ligne 147 puis correspondance vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Bondy, ville dynamique aux portes de Paris, est à moins de 20 minutes de Body by CC. Un court trajet pour bénéficier de soins esthétiques spécialisés peaux noires et métissées.',
    nearbyLandmarks: ['Forêt de Bondy', 'Gare RER E de Bondy', 'Centre-ville'],
  },
  {
    slug: 'bobigny',
    name: 'Bobigny',
    prefix: 'à',
    transport: {
      car: 'Via la A86 puis RN2 direction Sevran.',
      duration: '20 min en voiture',
      distance: '12 km',
      rer: 'Métro 5 (Bobigny Pablo Picasso) puis RER B direction Sevran.',
      bus: 'Tramway T1 + bus vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Bobigny, préfecture de la Seine-Saint-Denis, est reliée à Sevran par le réseau de transport dense du 93. Body by CC est accessible en 20 minutes pour des soins HIFU, laser et visage.',
    nearbyLandmarks: ['Préfecture du 93', 'MC93 Bobigny', 'Parc de la Bergère'],
  },
  {
    slug: 'noisy-le-sec',
    name: 'Noisy-le-Sec',
    prefix: 'à',
    transport: {
      car: 'Via la RN3 puis A104 direction Sevran.',
      duration: '20 min en voiture',
      distance: '11 km',
      rer: 'RER E (gare de Noisy-le-Sec) puis correspondance vers Sevran.',
      bus: 'Tramway T1 + bus vers Sevran.',
      parking: 'Parking gratuit disponible aux alentours de l\'institut.',
    },
    localContext: 'Noisy-le-Sec, ville bien desservie par le RER E et le tramway, permet de rejoindre Body by CC en 20 minutes. Un trajet court pour accéder à l\'un des meilleurs instituts du 93.',
    nearbyLandmarks: ['Parc Émile Zola', 'Gare RER E', 'Mairie de Noisy-le-Sec'],
  },
];
